export class Estabelecimento {

    sucesso: boolean;
    mensagens: Array<any>;
    codigoCNES: string;
    codigoUnidade: string;
    nomeFantasia: string;
    nomeEmpresarial: string;
    numeroCNPJ: string;
    cep: string;
    descricaoEndereco: string;
    descricaoBairro: string;
    codigoMunicipio: number;
    nomeMunicipio: string;
    codigoUF: number;
    siglaUF: string;
    ddTelefone: string;
    numTelefone: string;
    email: string;
    numero: string;
}



// WEBPACK FOOTER //
// ./src/app/model/estabelecimento.ts